import { useSettingsProducts } from 'app/components/settings-products/useSettingsProducts'
import { SettingsProductsShadcnComponent } from 'app/components/settings-products/SettingsProductsShadcnComponent'

export default function Products() {
  const props = useSettingsProducts()
  return <SettingsProductsShadcnComponent {...props} />
}
